import { Injectable } from "@angular/core";
import { QuickQuoteRequest } from "src/app/models/quick-quote-request";
import { QuoteModel } from "src/app/models/quote.model";
import { AnalyticsService } from "src/app/services/analytics.service";
import { ApiService } from "src/app/services/api.service";
import { CalculationService } from "src/app/services/calculation.service";

@Injectable()
export class QuickQuoteCIHelper {

    constructor(
        private api: ApiService,
        private calculator: CalculationService,
        private analyticsService: AnalyticsService
    ) {
    }

    async getCIQuote(quote: QuoteModel, sumAssured: number, term: number) {
        const answers = quote.answers.map(x => ({ Key: x.key, Value: x.value }));
        const typeOfPolicy = answers.find(x => x.Key === 'TypeOfPolicy_1')?.Value;
        const coverBasis = answers.find(x => x.Key === 'CoverBasis_1')?.Value;

        answers.push({ Key: 'ProtectionLevel_2', Value: sumAssured.toString() });
        answers.push({ Key: 'PolicyType_2', Value: 'TERM-CI' });
        answers.push({ Key: 'TypeOfPolicy_2', Value: typeOfPolicy });
        answers.push({ Key: 'CoverBasis_2', Value: coverBasis });
        answers.push({ Key: 'PolicyTerm_2', Value: term.toString() });

        const request = new QuickQuoteRequest(null, answers, false); // want a new quote so don't send quote key in
        request.parentKey = quote.parentKey ?? quote.key;
        request.sourceUrl = quote.sourceUrl ?? this.analyticsService.getFullPath('quick_quote');
        const rsp = await this.api.submitQuickQuote(quote.questionnaire, request);
        if (rsp.error) {
            return { error: rsp.error };
        }

        const newQuote = new QuoteModel(quote.questionnaire, {
            key: rsp.key,
            parentKey: quote.parentKey,
            answers: [...answers].map(x => ({ key: x.Key, value: x.Value })),
            result: rsp
        });

        return { quote: newQuote };
    }

    public getCITerm(quote: QuoteModel) {
        const answers = quote.answers.toDictionary(x => x.key, x => x.value);
        const minTerm = this.calculator.minPolicyTerm(
            answers['TypeOfPolicy_1'] == "DUAL",
            answers['FirstPolicyHolderDOB'],
            answers['SecondPolicyHolderDOB'],
            true
        );
        const maxTerm = this.calculator.maxPolicyTerm(
            answers['TypeOfPolicy_1'] == "DUAL",
            answers['FirstPolicyHolderDOB'],
            answers['SecondPolicyHolderDOB'],
            true
        );

        const term = parseInt(answers['PolicyTerm_1']);
        if (term > maxTerm)
            return maxTerm;
        else if (term < minTerm)
            return minTerm;
        else
            return term;
    }

    calculateSumAssured(sumAssured: number, multiplier: number) {
        if (isNaN(sumAssured)) {
            throw new Error("Invalid input: unable to convert string to number");
        }
        var percentage = 0;
        if (sumAssured <= 150000) {
            percentage = 25;
        } else if (sumAssured > 15000 && sumAssured < 450000) {
            percentage = 20;
        } else if (sumAssured > 451000) {
            percentage = 10;
        }

        return (sumAssured * (percentage / 100) * multiplier);
    }

}